export const STATUS_LABELS = {
  confirmed: '확정',
  completed: '완료',
  cancelled: '취소',
  pending: '대기',
  rejected: '거절',
};

export const STATUS_COLORS = {
  confirmed: '#4a9fff',
  completed: '#4caf50',
  cancelled: '#ff5252',
  pending: '#ff9800',
  rejected: '#9e9e9e',
};

export const FILTER_TABS = [
  { key: 'all', label: '전체' },
  { key: 'pending', label: '대기' },
  { key: 'confirmed', label: '확정' },
  { key: 'completed', label: '완료' },
  { key: 'cancelled', label: '취소' },
];

export function getToday() {
  return new Date().toISOString().slice(0, 10);
}

export function getWeekRange() {
  const now = new Date();
  const start = new Date(now);
  start.setDate(now.getDate() - now.getDay());
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return { start: start.toISOString().slice(0, 10), end: end.toISOString().slice(0, 10) };
}
